import { useState, useEffect, useMemo } from "react";
import sessionTimer from "../util/session-timer";

const useSessionActive = () => {
  const [sessionActive, setSessionActive] = useState(true);

  const hookId = useMemo(() => Math.floor(Math.random() * 100), []);

  useEffect(() => {
    sessionTimer.setCallbacks({
      hookId,
      handleSessionTimeout: () => setSessionActive(false),
      handleSessionRestart: () => setSessionActive(true)
    });
    return () => {
      sessionTimer.removeCallBacks(hookId);
    };
  }, [hookId]);

  return sessionActive;
};

export default useSessionActive;
